import { render, staticRenderFns } from "./TheChart.vue?vue&type=template&id=1e381041&scoped=true"
import script from "./TheChart.vue?vue&type=script&lang=ts"
export * from "./TheChart.vue?vue&type=script&lang=ts"
import style0 from "./TheChart.vue?vue&type=style&index=0&id=1e381041&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e381041",
  null
  
)

export default component.exports